module.exports = {"domain":"zeno.turingvideo.cn","server":"https://zeno.turingvideo.cn","api_path":"/api/v1"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 43
// module chunks = 0